<div class="totals-row" [class.visible]="visible">

  <div class="totals-content">
    <div class="total-item">
      <span class="label">{{ 'COMMON.SUBTOTAL' | translate }}</span>
      <span class="value">{{ subtotal | currency: 'EUR' }}</span>
    </div>

    <div class="total-item">
      <span class="label">{{ 'COMMON.TOTAL' | translate }}</span>
      <span class="value">{{ total | currency: 'EUR' }}</span>
    </div>
  </div>

</div>
